/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/no-var-requires */
// const CryptoJS = require('crypto-js');

export function getSignature() {
  // // eslint-disable-next-line no-debugger
  // debugger;
  const signature = document.getElementById('ITIDA_SIGNATURE');
  return JSON.parse(signature?.value);
}

export async function simulateMouseClick(el) {
  // // eslint-disable-next-line no-debugger
  // debugger;
  const opts = { view: window, bubbles: true, cancelable: true, buttons: 1 };
  el.dispatchEvent(new MouseEvent('mousedown', opts));
  await new Promise(r => setTimeout(r, 50));
  el.dispatchEvent(new MouseEvent('mouseup', opts));
  el.dispatchEvent(new MouseEvent('click', opts));
}

export function openSigningForm() {
  // // eslint-disable-next-line no-debugger
  // debugger;
  document.getElementById('ITIDA-OPEN-CERT-STORE-BTN').click();
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

// export function getHash(content) {
//   // eslint-disable-next-line no-debugger
//   debugger;
//   const hash = CryptoJS.SHA256(content);
//   const elem = document.getElementById("hashValue");
//   elem.value = hash;
//   const hashBase64 = btoa(String.fromCharCode.apply(null, elem.value.replace(/\r|\n/g, "").replace(/([\da-fA-F]{2}) ?/g, '0x$1 ').replace(/ +$/, "").split(" ")));
//   return hashBase64;
// }

// export async function handleDocument(contentBase64, hashBase64) {
//   const arr = [];
//   const item = { hash: hashBase64, data: contentBase64 };
//   arr.push(item);
//   window.dataHashToBeSignedList = JSON.stringify(arr);
//   return true;
// };

export async function handleDocument(content) {
  // // eslint-disable-next-line no-debugger
  // debugger;
  const arr = [];
  content.forEach(element => {
    if(element.shA256 && element.signableDataBase64){
      // for test purpose only.
      // const data = 'IklTU1VFUiIiQUREUkVTUyIiQlJBTkNISUQiIjAiIkNPVU5UUlkiIkVHIiJHT1ZFUk5BVEUiIkNhaXJvIiJSRUdJT05DSVRZIiJOZXcgTWlueWEiIlNUUkVFVCIiRGUgbGEgcm91Y2giIkJVSUxESU5HTlVNQkVSIiIyMyIiUE9TVEFMQ09ERSIibnVsbCIiRkxPT1IiIm51bGwiIlJPT00iIjIiIkxBTkRNQVJLIiJudWxsIiJBRERJVElPTkFMSU5GT1JNQVRJT04iIm51bGwiIlRZUEUiIkIiIklEIiIxMDA1MzYxOTAiIk5BTUUiItin2YTZgdis2LEg2YTYqtis2KfYsdmHINin2YTYrtmK2YjYtyDZiNin2YTZhdmG2LPZiNis2KfYqiDZiNin2YTZhdmE2KfYqNizINin2YTYrNin2YfYstipINi52KjYryDYp9mE2K3ZhNmK2YUiIlJFQ0VJVkVSIiJBRERSRVNTIiJUWVBFIiJQIiJJRCIiMjk2MTExMjAxMDA1NzgiIk5BTUUiItmF2K3ZhdivINin2YTYs9mK2K8g2LnYqNivINin2YTYrdmF2YrYryDYtNmE2KjZiiDZiNi02LHZg9in2YcgXCLYp9mD2KfYr9mK2YXZiiDYqtmI2LHYslwiIiJET0NVTUVOVFRZUEUiImkiIkRPQ1VNRU5UVFlQRVZFUlNJT04iIjEuMCIiREFURVRJTUVJU1NVRUQiIjIwMjEtMDYtMjFUMTc6MzU6NTRaIiJJTlRFUk5BTElEIiI3MjI1NDUzNTAzMTgiIlJFRkVSRU5DRVMiIlBBWU1FTlQiIkRFTElWRVJZIiJJTlZPSUNFTElORVMiIklOVk9JQ0VMSU5FUyIiREVTQ1JJUFRJT04iIti02KfZg9mI2LQg2LXZhNioIDIg2YMiIklURU1UWVBFIiJHUzEiIklURU1DT0RFIiIxMDAwMDAwMDAwMDAzIiJVTklUVFlQRSIiS0dNIiJRVUFOVElUWSIiMjAiIklOVEVSTkFMQ09ERSIiIiJTQUxFU1RPVEFMIiI0MDAwIiJUT1RBTCIiNDAwMCIiVkFMVUVESUZGRVJFTkNFIiIwIiJUT1RBTFRBWEFCTEVGRUVTIiIwIiJORVRUT1RBTCIiNDAwMCIiSVRFTVNESVNDT1VOVCIiMCIiVU5JVFZBTFVFIiJDVVJSRU5DWVNPTEQiIkVHUCIiQU1PVU5URUdQIiIyMDAiIkRJU0NPVU5UIiJSQVRFIiIwIiJBTU9VTlQiIjAiIlRBWEFCTEVJVEVNUyIiVEFYVE9UQUxTIiJUQVhQQVlFUkFDVElWSVRZQ09ERSIiNDY0MSIiVE9UQUxESVNDT1VOVEFNT1VOVCIiMCIiVE9UQUxTQUxFU0FNT1VOVCIiNDAwMCIiTkVUQU1PVU5UIiI0MDAwIiJUT1RBTEFNT1VOVCIiNDAwMCIiRVhUUkFESVNDT1VOVEFNT1VOVCIiMCIiVE9UQUxJVEVNU0RJU0NPVU5UQU1PVU5UIiIwIg==';
      const item = { hash: element.shA256, data: element.signableDataBase64};
      arr.push(item);
    }
  });
  
  window.dataHashToBeSignedList = JSON.stringify(arr);
  return true;
};